var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneOlive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-check 1",
    clipPath: "url(#clip0_355_26635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.441406 9.48348C0.441406 4.52057 4.42034 0.498291 9.32977 0.498291C14.2392 0.498291 18.2181 4.52057 18.2181 9.48348C18.2181 14.4464 14.2392 18.4687 9.32977 18.4687C4.42034 18.4687 0.441406 14.4464 0.441406 9.48348ZM13.3504 7.93213C13.7288 7.54956 13.7288 6.92481 13.3504 6.54223C12.9719 6.15966 12.3539 6.15966 11.9755 6.54223L8.21873 10.3399L6.6841 8.78853C6.30564 8.40596 5.68763 8.40596 5.30918 8.78853C4.93073 9.1711 4.93073 9.79585 5.30918 10.1784L7.53127 12.4247C7.90972 12.8073 8.52774 12.8073 8.90619 12.4247L13.3504 7.93213Z",
    fill: "#808000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_26635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7767,
    height: 17.9704,
    fill: "white",
    transform: "translate(0.441406 0.498291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneOlive);
export default __webpack_public_path__ + "static/media/doneOlive.6bf382acb1eb03e19cf5dc5557c512d7.svg";
export { ForwardRef as ReactComponent };